module.exports = __webpack_public_path__ + "img/kr.4d7928d0.svg";